<template>
    <div class="">

        <div id="chatDetails fixed z-20 top-4 left-0">
            <div id="detailsHead" class="flex justify-between ">
                <h1 class=" font-extrabold text-[20px] text-[#0741AB]">
                    <slot name="title" ></slot>
                </h1>
                <div>
                    <slot name="head_info"></slot>
                </div>
            </div>
            <div id="details_body">
                <slot name="details_body"></slot>
            </div>
        </div>
        <div id="chatContent" class="flex flex-col gap-4 h-full">
            <div v-for="message in messaggi" class="flex gap-3">
                <div class="w-[42px] h-[42px] text-center leading-[42px] rounded-full bg-blue-500 text-white font-bold text-[16px] flex-shrink-0 mt-1">
                    {{ message.creatore === 'Segnalatore' ? 'S' : 'G' }}
                </div>
                <div class="flex-1">
                    <div class="bg-gray-100 rounded-lg p-4 shadow-sm">
                        <div class="flex justify-between items-center mb-2">
                            <span class="font-bold text-sm text-gray-700">
                                {{ message.creatore === 'Segnalatore' ? 'Segnalatore' : 'Gestore Whistleblowing' }}
                            </span>
                            <span class="text-xs text-gray-500">
                                {{ new Date(message.creato).toLocaleString('it-IT') }}
                            </span>
                        </div>
                        <div class="text-gray-800" v-html="sanitize(message.commento)"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import DOMPurify from 'dompurify';
export default {
    name:"Chat",
    components: {},
    props: [ 'messages', 'messaggioprincipale', 'allegati' ],
    data(){
        return {
            messaggi: this.messages,
            messaggioprincipale: this.messaggioprincipale,
            allegati: this.allegati,
        }
    },
    beforeCreate(){
        console.log(this.messages, this.messaggioprincipale, this.allegati);
    },
    created(){

    },
    mounted(){

    },
    methods: {
        sanitize(html) {
            return DOMPurify.sanitize(html);
        }
    }
}
</script>

<style scoped>

</style>
